import Pikaday from '../vendor/pikaday';

{
	const inputs = Array.from(document.querySelectorAll('.js-form-date'));

	inputs.forEach(function createDatePicker(input) {
		new Pikaday({
			field: input,
			firstDay: 1,
			format: 'DD/MM/YYYY',
			theme: 'date-picker',
			toString(date) {
				const year = date.getFullYear();
				const month = `${date.getMonth() + 1}`;
				const day = `${date.getDate()}`;

				return [day, month, year].join('/');
			},
			parse(dateString) {
				const parts = dateString.split('/');
				const day = parseInt(parts[0], 10);
				const month = parseInt(parts[1], 10) - 1;
				const year = parseInt(parts[2], 10);

				return new Date(year, month, day);
			},
		});

		// Prevent onscreen keyboard on iOS, Android, etc.
		input.setAttribute('readonly', 'true');
		input.setAttribute('autocomplete', 'off');
	});
}
